import React from 'react';
import './styles1.css';

function Header() {
    return (
        <div className="header">
            <h1>Keeper</h1>
        </div>
    );
}

export default Header;